import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import UsbTwoToneIcon from '@material-ui/icons/UsbTwoTone';
import Fab from '@material-ui/core/Fab';
import Conexao from '../../providers/Conexao'
import {Grid, TextField, Divider, InputAdornment} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import IconeLocalizarClienteModal from '../../components/IconeLocalizarClienteModal'
import Swal from 'sweetalert2'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function ModalNovaLicenca(props) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [dataEmpresa, setDataEmpresa]= React.useState([]);
  const [cliente, setCliente] = React.useState({
    idcliente : '', 
    razaosocial : ''
})


  const handleClickOpen = () => {
    setOpen(true);
    setCliente({
        idcliente : '', 
        razaosocial : '', 
        idclienteinterno : ''
    })
  };
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(()=>{
    if(open){
      getDetalhesEmpresa()
    }
    
  },[open] )

  const getDetalhesEmpresa = () =>{ 
    setLoading(true)
    Conexao.get('empresasController/getDetalheEmpresa?idempresa='+props.idempresa).then(response =>{
        if(response.data.status =='OK'){
            setDataEmpresa(response.data.payload);
        }else{
            setDataEmpresa([])
        }
        setLoading(false)
    }).catch(error =>{
        setDataEmpresa([])
        setLoading(false)
    });
  }


  const insertDca = () =>{ 
    setLoading(true)
    Conexao.post('dcaController/insertLicencaCollector', {
        idusuario : props.idusuario, 
        idempresa : props.idempresa, 
        idcliente :cliente.idcliente , 
        razaosocial : cliente.razaosocial, 
        chave : dataEmpresa.chaveparcial, 
        codigoClienteERP : cliente.idclienteinterno
    }).then(response =>{
      
        if(response.data.status.trim() == 'OK'){
          Swal.fire({
              title : 'Datacount', 
              text : 'Licença Collector inserido com sucesso !', 
              showConfirmButton : false, 
              showCancelButton : false,
              icon : 'success', 
              timer : 1500
          })
          setLoading(false)
          props.getData()
        }else{
          setLoading(false)
            Swal.fire({
                title : 'Datacount', 
                text : 'Não foi possível inserir Licença Collector', 
                showConfirmButton : false, 
                showCancelButton : false,
                icon : 'warning', 
                timer : 1500
            })
        }
        setOpen(false)
    }).catch(error =>{
      setLoading(false)
        Swal.fire({
            title : 'Datacount', 
            text : 'Não foi possível inserir Licença Collector', 
            showConfirmButton : false, 
            showCancelButton : false,
            icon : 'warning', 
            timer : 1500
        })
        setOpen(false)
    });
  }
  return (
    <div>
     
      <Fab color="primary" aria-label="add" onClick={handleClickOpen}>
            <UsbTwoToneIcon />
        </Fab>
      <Dialog 
        maxWidth='sm'
        fullWidth
        onClose={handleClose} 
        aria-labelledby="customized-dialog-title" 
        open={open} hideBackdrop 
        disableBackdropClick 
        disableEscapeKeyDown>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Nova Licença Collector
        </DialogTitle>
        <DialogContent dividers>

        <Grid container spacing = {2}>
              <Grid item xs = {3}>
                  <Typography variant='subtitle2'>CNPJ Revenda</Typography>
              </Grid>
              <Grid item xs = {5}>
                <TextField
                   
                    variant = 'outlined'
                    fullWidth
                    value = {dataEmpresa.cnpjempresa}
                    InputLabelProps ={{shrink : true}}/>
              </Grid>

          </Grid>

          <Grid container spacing = {2}>
              <Grid item xs = {3}>
                  <Typography variant='subtitle2'>Razão Social</Typography>
              </Grid>
              <Grid item xs = {9}>
                <TextField
                   
                    variant = 'outlined'
                    fullWidth
                    value = {dataEmpresa.razaosocial}
                    InputLabelProps ={{shrink : true}}/>
              </Grid>
          </Grid>




          <Grid container spacing = {2}>
              <Grid item xs = {3}>
              <Typography variant='subtitle2'>Chave Parcial</Typography>
              </Grid>
              <Grid item xs = {5}>
                  <TextField
                   
                    variant = 'outlined'
                    fullWidth
                    value = {dataEmpresa.chaveparcial}
                    InputLabelProps ={{shrink : true}}/>
              </Grid>

              
          </Grid>
          
          <Grid container spacing = {2}>
              <Grid item xs = {3}>
              <Typography variant='subtitle2'>Código Cliente</Typography>
              </Grid>
              <Grid item xs = {3}>
                <TextField
                    variant = 'outlined'
                    fullWidth
                    value = {cliente.idcliente}
                    InputLabelProps ={{shrink : true}}
                    InputProps ={{
                        startAdornment : (
                            <InputAdornment position ='start'>                              
                                {!loading && <IconeLocalizarClienteModal idusuario={props.idusuario} idempresa={props.idempresa} selectCliente = {(cliente)=>setCliente({
                                    idcliente : cliente.idcliente, 
                                    razaosocial : cliente.razaosocial, 
                                    idclienteinterno : cliente.idclienteinterno
                                })}
                                
                                />}
                            </InputAdornment>
                        )
                    }} 
                   
                    />
              </Grid>

              
          </Grid>

          <Grid container spacing = {2}>
              <Grid item xs = {3}>
              <Typography variant='subtitle2'>Razão Social Cliente</Typography>
              </Grid>
              <Grid item xs = {9}>
                <TextField
                    
                    variant = 'outlined'
                    fullWidth
                    value = {cliente.razaosocial}
                    InputLabelProps ={{shrink : true}}/>
              </Grid>

              
          </Grid>


          
        </DialogContent>
        <DialogActions>
          <Button color ='secondary' disabled = {loading} onClick={handleClose} variant='contained'>Cancelar</Button>
          <Button autoFocus disabled = {loading} onClick={()=>{
              Swal.fire({
                  title : 'Datacount', 
                  text :'Deseja cadastrar uma nova Licença do Módulo Collector ?', 
                  showConfirmButton : true, 
                  confirmButtonText : 'Confirmar', 
                  showCancelButton : true, 
                  cancelButtonText : 'Cancelar',
                  icon : 'question'
              }).then(response=>{
                  if(response.isConfirmed){
                    insertDca();
                  }
              })
          }} color="primary"  variant='contained'>
            Gravar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
